<template>
     <h5 v-if="percentMe >= 0">My data
        <ProgressBar :percent="percentMe" />
     </h5>
</template>
<script>
import ProgressBar from '@/components/ProgressBar';
export default {
    name: "ProgressBarMe",
    components: {
        ProgressBar,
    },
    computed: {
        percentMe() {
            return this.$store.state.me.loading;
        },
    }
}
</script>
<style>

</style>